import { select, call, put } from 'redux-saga/effects';
import bugsnagClient from '../../../services/bugsnag/bugsnag';
import { setCallAssistantQuota } from '../../../state/assistant/assistantQuotaSlice';
import { backendClient } from '../../../services/api/backend-client';

export function* fetchCallAssistantQuotaSaga(action) {
    try {
        const { data } = yield call(
            [backendClient, backendClient.get],
            '/realtime/quota/audio'
        );

        yield put(setCallAssistantQuota(data));

    } catch (err) {
        const status = err?.response?.status;
        bugsnagClient.notify(err);
        console.error('Failed to fetch call assistant quota:', status, err?.message);
    }
}